import requests from '../../../../redux/reducer/requests'
import content from '../../../../redux/reducer/content'
import { useDispatch } from 'react-redux'

export default function useProductsCallbacks() {
  const dispatch = useDispatch()

  return {
    getBuyProducts: () => dispatch(requests.thunks.getBuyProducts()),
    useBuyProduct: (id) => dispatch(requests.thunks.useBuyProduct(id)),
    getFavoritesProducts: () => dispatch(requests.thunks.getFavoritesProducts()),
    productToFavorites: (sku) => dispatch(requests.thunks.productToFavorites(sku)),
    productToCart: (sku) => dispatch(requests.thunks.productToCart(sku)),
    getWebCatalogProductsBySku: (params) =>
      dispatch(requests.thunks.getWebCatalogProductsBySku(params)),
    getWebCatalogProductsBySkuBeautyRoutine: (params) =>
      dispatch(requests.thunks.getWebCatalogProductsBySkuBeautyRoutine(params)),
    resetProductsFromGA: () => dispatch(content.actions.resetProductsFromGA()),
  }
}
